var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.getCurrentUser)?[_c('v-app',[_c('v-main',[_c('NavBar',{attrs:{"auth":"CONTABILIDAD"}}),_c('Sidebar'),_c('router-view')],1)],1)]:[_c('Login')]],2)}
var staticRenderFns = []

export { render, staticRenderFns }